import React, { useState, useRef } from 'react'
import { Modal, Button } from '../ui'

export function ReportTagModal({ report, onUpdateTags, onClose }) {
  const [tags, setTags] = useState(report.tags || [])
  const [input, setInput] = useState('')
  const [saving, setSaving] = useState(false)
  const inputRef = useRef(null)

  async function save(nextTags) {
    setSaving(true)
    try {
      await onUpdateTags(report.reportId, nextTags)
      setTags(nextTags)
    } finally {
      setSaving(false)
    }
  }

  function addTag() {
    const tag = input.trim().toLowerCase()
    if (!tag || tags.includes(tag)) { setInput(''); return }
    const next = [...tags, tag]
    setInput('')
    save(next)
  }

  function removeTag(tag) {
    save(tags.filter((t) => t !== tag))
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') { e.preventDefault(); addTag() }
  }

  const title = report.reportName || report.reportEmail

  return (
    <Modal
      open
      onClose={onClose}
      title={title}
      width="sm"
      initialFocusRef={inputRef}
    >
      <p style={styles.email}>{report.reportEmail}</p>

      <p style={styles.label}>Tags</p>
      <div style={styles.chips}>
        {tags.length === 0 && <span style={styles.empty}>No tags yet</span>}
        {tags.map((tag) => (
          <span key={tag} style={styles.chip}>
            {tag}
            <button
              type="button"
              style={styles.chipRemove}
              onClick={() => removeTag(tag)}
              aria-label={`Remove ${tag}`}
              disabled={saving}
            >
              ×
            </button>
          </span>
        ))}
      </div>

      <div style={styles.inputRow}>
        <input
          ref={inputRef}
          style={styles.input}
          placeholder="Add a tag and press Enter"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={saving}
        />
        <Button onClick={addTag} disabled={saving || !input.trim()}>Add</Button>
      </div>
    </Modal>
  )
}

const styles = {
  email: {
    fontSize: 12,
    color: 'var(--text-secondary)',
    margin: 0,
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: 'var(--text-secondary)',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    margin: 0,
  },
  chips: { display: 'flex', flexWrap: 'wrap', gap: 6, minHeight: 28, alignItems: 'center' },
  empty: { fontSize: 12, color: 'var(--text-secondary)' },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 12,
    padding: '3px 8px',
    borderRadius: 'var(--radius-pill)',
    background: 'var(--border)',
    color: 'var(--text-primary)',
  },
  chipRemove: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    fontSize: 14,
    color: 'var(--text-secondary)',
    lineHeight: 1,
  },
  inputRow: { display: 'flex', gap: 8 },
  input: {
    flex: 1,
    padding: '7px 10px',
    fontSize: 13,
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-md)',
    background: 'var(--surface)',
    color: 'var(--text-primary)',
  },
}
